import { registerHttpRequest } from '@/services/api/http.service';
import { getAppLog } from '@/services/log.service';
import Vue from 'vue';

const state = {
  logByCategory: {},
  nextLogByCategory: {},
  historyDates: [],
  historyDatesChecked: false,
  historySelectedGroup: '',
  loadingHistory: false,
};

// Getter functions
const getters = {};

// Mutations
const mutations = {
  setLogByCategory(state, { category, log, nextData }) {
    if (!state.logByCategory[category]) {
      Vue.set(state.logByCategory, category, []);
    }
    state.logByCategory[category].push(...log);
    Vue.set(state.nextLogByCategory, category, nextData);
  },
  clearLogByCategory(state, { category }) {
    Vue.set(state.logByCategory, category, []);
    Vue.set(state.nextLogByCategory, category, {});
  },
  setHistoryDates(state, payload) {
    state.historyDates = payload;
  },
  setHistoryDatesChecked(state, payload) {
    state.historyDatesChecked = payload;
  },
  setHistorySelectedGroup(state, payload) {
    state.historySelectedGroup = payload;
  },
  setLoadingHistory(state, status) {
    state.loadingHistory = status;
  },
};

// Actions
const actions = {
  async fetchLogByCategory({ commit }, payload) {
    commit('setLoadingHistory', true);
    registerHttpRequest('getAppLog', payload);
    const log = await getAppLog(payload);
    if (log._isCancel) {
      return false;
    }

    commit('setLoadingHistory', false);
    commit('setLogByCategory', {
      category: payload.category,
      log: log.list.map((item, index) => ({
        ...item,
        id: index + payload.offset,
      })),
      nextData: log.isNextData,
    });
    return !!log.isNextData;
  },
  clearLogByCategory({ commit }, payload) {
    commit('clearLogByCategory', { category: payload.category });
  },
  setHistoryDates({ commit }, payload) {
    commit('setHistoryDates', payload);
  },
  setHistoryDatesChecked({ commit }, payload) {
    commit('setHistoryDatesChecked', payload);
  },
  setHistorySelectedGroup({ commit }, payload) {
    commit('setHistorySelectedGroup', payload);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
